import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { adminService } from '../services/adminService';
import { AdminEvent, CreateAdminEventInput, UpdateAdminEventInput } from '../types/adminCalendar';

export const adminCalendarKeys = {
  all: ['adminCalendar'] as const,
  events: (start?: string, end?: string) => [...adminCalendarKeys.all, 'events', start, end] as const,
};

export function useAdminCalendarEvents(start?: string, end?: string) {
  return useQuery<AdminEvent[], Error>({
    queryKey: adminCalendarKeys.events(start, end),
    queryFn: () => adminService.getAdminEvents(start, end),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useCreateAdminEvent() {
  const qc = useQueryClient();
  return useMutation<AdminEvent, Error, CreateAdminEventInput>({
    mutationFn: (input) => adminService.createAdminEvent(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminCalendarKeys.all });
    },
  });
}

export function useUpdateAdminEvent() {
  const qc = useQueryClient();
  return useMutation<AdminEvent, Error, { id: string; input: UpdateAdminEventInput }>({
    mutationFn: ({ id, input }) => adminService.updateAdminEvent(id, input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminCalendarKeys.all });
    },
  });
}

export function useDeleteAdminEvent() {
  const qc = useQueryClient();
  return useMutation<void, Error, string>({
    mutationFn: (id) => adminService.deleteAdminEvent(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminCalendarKeys.all });
    },
  });
}
